import React from "react";

import { skeletonStyle } from "./skeleton.css";
import { fontSizes, SpacingKeys } from "@puzzle/theme";

const DEFAULT_VARIANT = "rounded";
const DEFAULT_WIDTH = "100%";
const DEFAULT_HEIGHT = fontSizes.body;

export const TEST_IDS = {
  SKELETON: "@ve/skeleton",
};

export type SkeletonProps = {
  /**
   * The shape of the skeleton.
   * @default "rounded"
   */
  variant?: "rounded" | "rectangular";
  /**
   * The width of the skeleton.
   * @default "100%"
   */
  width?: string;
  /**
   * The height of the skeleton.
   * @default "fontSizes.body"
   */
  height?: string;
  /**
   * Whether the skeleton is animated.
   * @default false
   */
  animated?: boolean;
  /**
   * Whether Skeleton should be displayed
   * @default true
   */
  visible?: boolean;
  /**
   * The radius of the skeleton.
   * @default ""
   */
  radius?: SpacingKeys;
};

export const Skeleton = ({
  variant = DEFAULT_VARIANT,
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  animated = false,
  visible = true,
  radius,
}: SkeletonProps) => {
  const skeletonClassName = skeletonStyle({
    variant,
    animated,
    radius,
  });

  if (!visible) return null;

  return (
    <div
      data-testid={TEST_IDS.SKELETON}
      className={`${skeletonClassName} ${variant}`}
      style={{ width, height }}
    ></div>
  );
};
